import { Preloader } from './Preloader';
import { ResizeMode } from './ResizeMode';

export class PlatformSettings {
  antialiasing: boolean;
  forceCanvasRendering: boolean;
  resizeMode: ResizeMode;
  // Minimum backbuffer width in device pixels. When > 0, the canvas backbuffer is
  // upscaled to this width on small/low-DPR windows (CSS display size is unchanged),
  // restoring render sharpness. 0 disables the behavior (default — no effect).
  minBackbufferWidth: number;

  private _top: number = 0;

  constructor(
    antialiasing: boolean = false,
    forceCanvasRendering: boolean = false,
    _enableCompressedTextures: boolean = false,
    resizeMode: ResizeMode = ResizeMode.Resize,
    minBackbufferWidth: number = 0
  ) {
    this.antialiasing = antialiasing;
    this.forceCanvasRendering = forceCanvasRendering;
    this.resizeMode = resizeMode;
    this.minBackbufferWidth = minBackbufferWidth;
  }

  set top(value: number) {
    this._top = value;
  }

  get top(): number {
    return this._top;
  }

  private _preloader: Preloader;

  set preloader(preloader: Preloader) {
    this._preloader = preloader;
  }

  get preloader(): Preloader {
    return this._preloader;
  }
}
